import { render } from "./Volume.vue?vue&type=template&id=1b074538&scoped=true&ts=true&lang=pug"
import script from "./Volume.vue?vue&type=script&lang=ts"
export * from "./Volume.vue?vue&type=script&lang=ts"

import "./Volume.vue?vue&type=style&index=0&id=1b074538&scoped=true&lang=css"

import exportComponent from "E:\\UiDesk\\laragon-5.0.0\\www\\click-to-call\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b074538"]])

export default __exports__